/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destructive_Writes_Org_OffInputs */



/**
* | output |
* | --- |
* | "Your organization does not allow unattended irreversible actions. An administrator can enable them in the agent policy." |
*
* @param {Agent_Builder_Destructive_Writes_Org_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destructive_writes_org_off = /** @type {((inputs?: Agent_Builder_Destructive_Writes_Org_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destructive_Writes_Org_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Organisation erlaubt keine unbeaufsichtigten unumkehrbaren Aktionen. Eine Administratorin oder ein Administrator kann sie in der Agent-Richtlinie aktivieren.")
	return /** @type {LocalizedString} */ ("Your organization does not allow unattended irreversible actions. An administrator can enable them in the agent policy.")
});